export default {
footer: {
    ageRestriction: "ہمارا پلیٹ فارم صرف 18 سال اور اس سے اوپر کے صارفین کے لیے ہے۔ جوا کھیلنا لت کا باعث بن سکتا ہے۔ براہ کرم ذمہ داری کے ساتھ اور صرف تفریح کے لیے کھیلیں۔ مزید معلومات کے لیے، ہمارے ذمہ دارانہ گیمنگ کے صفحے پر جائیں۔",
    followUs: "ہمیں فالو کریں",
    company: "کمپنی",
    legal: "قانونی",
    support: "سپورٹ",
    gameProviders: "گیم فراہم کنندگان",
    copyright: "Copyright © 2019-2026 LOGO. جملہ حقوق محفوظ ہیں۔",
	documents: "دستاویزات",
  }
}
